// extracted by mini-css-extract-plugin
export var fadePop = "Button-module--fade-pop--35671";
export var growHeightIn = "Button-module--grow-height-in--b413c";
export var primary = "Button-module--primary--b8701";
export var secondary = "Button-module--secondary--9bc82";
export var tertiary = "Button-module--tertiary--a1bca";